export let LiveSiteMenuStatusCardDisplayed = /*#__PURE__*/function (LiveSiteMenuStatusCardDisplayed) {
  LiveSiteMenuStatusCardDisplayed["DISPLAYED"] = "displayed";
  LiveSiteMenuStatusCardDisplayed["COLLAPSED"] = "collapsed";
  return LiveSiteMenuStatusCardDisplayed;
}({});
export let LiveSiteMenuStatusCardDisplayedPageName = /*#__PURE__*/function (LiveSiteMenuStatusCardDisplayedPageName) {
  LiveSiteMenuStatusCardDisplayedPageName["DISH_MODAL"] = "dish modal";
  LiveSiteMenuStatusCardDisplayedPageName["OLO_PAGE"] = "olo page";
  return LiveSiteMenuStatusCardDisplayedPageName;
}({});
//# sourceMappingURL=constants.js.map